import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from '../../services/config.service';
import { RestApiService } from '../../services/rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class MITableService {

  constructor(private restApiService: RestApiService, private configService: ConfigService) { }

  bulkRowCount = new BehaviorSubject(null);
  selectedRows = new BehaviorSubject(null);

  updateUserEntityConfig(entityCode: string, data: any, viewCode: string) {
    return this.restApiService.post('Update user entity preferences', `${this.configService.getForTenantCode()}/api/v1/entity-conf/${entityCode}/user-preferences?viewCode=${viewCode}`, data, 'page-center');
  }


  getUserEntityConfig(entityCode: string, prefType: string, viewCode: string) {
    return this.restApiService.get('GET USER ENTITY CONFIG', `${this.configService.getForTenantCode()}/api/v1/entity-conf/${entityCode}/user-preferences/${prefType}?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${viewCode}`, 'page-center');
  }

}
